import { render, staticRenderFns } from "./IconMealplanFilled.vue?vue&type=template&id=499967da&scoped=true"
import script from "./IconMealplanFilled.vue?vue&type=script&lang=js"
export * from "./IconMealplanFilled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499967da",
  null
  
)

export default component.exports